// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-input-docs',
    templateUrl: './input.docs.generated.html',
})
export class UIInputDocs { }
